module.exports = __webpack_public_path__ + "img/1516511907.6cb352f4.jpg";